export default "__VITE_ASSET__BEkl8ufT__"